import ErrorBanner from "../ErrorBanner";
import PropTypes from "prop-types";

export default function TopBar({ id, children }) {
    return (
        <div
            id={id}
            className="flex h-18.5 w-full items-center justify-between bg-white px-4"
        >
            {children}
            <ErrorBanner />
        </div>
    );
}

TopBar.propTypes = {
    id: PropTypes.string,
    children: PropTypes.any,
};
